import React from "react"

import type { UseFloatingProps } from "@floating-ui/react"
import {
  useFloating,
  FloatingPortal,
  autoUpdate,
  offset,
  flip,
} from "@floating-ui/react"
import styled from "styled-components"

const Wrapper = styled.div`
  position: relative;
  &[data-disabled="false"] {
    &,
    * {
      cursor: help;
    }
  }
`

const Message = styled.div`
  position: absolute;
  background-color: var(--blue);
  border-radius: 8px;
  padding: 15px;
  z-index: 9999;
  pointer-events: none;
  box-shadow: 0 10px 30px 0px rgba(0, 64, 137, 0.35);
  p {
    color: white;
    font-size: var(--step--1);
    font-weight: 500;
  }
`

export const NewTooltip: React.FC<{
  children: React.ReactNode
  messageStyle?: React.CSSProperties
  floatingProps?: Partial<UseFloatingProps>
  disabled?: boolean
  message?: string
  wrapperStyle?: React.CSSProperties
}> = ({
  children,
  messageStyle,
  message,
  floatingProps,
  disabled,
  wrapperStyle,
}) => {
  const [open, setOpen] = React.useState<boolean>(false)
  const { refs, x, y } = useFloating({
    open,
    whileElementsMounted: autoUpdate,
    strategy: `absolute`,
    placement: `right`,
    ...floatingProps,
    middleware: [
      offset({
        mainAxis: 10,
        crossAxis: 0,
      }),
      flip({
        rootBoundary: `viewport`,
        crossAxis: false,
      }),
    ],
  })

  return (
    <Wrapper
      ref={refs.setReference}
      onPointerEnter={() => setOpen(true)}
      onPointerLeave={() => setOpen(false)}
      data-disabled={disabled}
      style={wrapperStyle}
    >
      {children}
      {open && message && !disabled && (
        <FloatingPortal>
          <Message
            ref={refs.setFloating}
            style={{
              top: y ?? 0,
              left: x ?? 0,
              ...messageStyle,
            }}
          >
            <p>{message}</p>
          </Message>
        </FloatingPortal>
      )}
    </Wrapper>
  )
}
